import React from 'react';
import Sean1 from '../imgs/Sean1.jpg';
import Sean2 from '../imgs/Sean2.jpg';
import Sean3 from '../imgs/Sean3.jpg';
import Group from '../imgs/Group.jpg';

const About: React.FC = () => {
  return (
    <div className="min-h-screen bg-lighttan pb-12 md:pb-24">
        <div className="relative bg-tantext flex items-center py-16">
        <div className="md:hidden max-w-7xl mx-auto mt-20 px-4 space-y-4">
            <img
                src={Sean1}
                alt="Sean Clark"
                className="w-full h-64 object-cover shadow-lg"
            />
            <img
                src={Group}
                alt="Group"
                className="w-full h-64 object-cover shadow-lg"
            />
            <img
                src={Sean2}
                alt="Sean Clark"
                className="w-full h-64 object-cover shadow-lg"
            />
            <img
                src={Sean3}
                alt="Right Vertical"
                className="w-full h-64 object-cover shadow-lg"
            />
        </div>
        
        <div className="hidden md:grid grid-cols-3 gap-4 max-w-7xl mx-auto mt-28">
            <img
                src={Sean1}
                alt="Sean Clark"
                className="w-full h-5/6 object-cover shadow-lg"
            />
            <div className='flex flex-col'>
                <img
                    src={Group}
                    alt="Group"
                    className="w-full h-64 object-cover shadow-lg mb-6"
                />
                <img
                    src={Sean2}
                    alt="Sean Clark"
                    className="w-full h-60 object-cover shadow-lg"
                />
            </div>
            <img
                src={Sean3}
                alt="Right Vertical"
                className="w-full h-5/6 object-cover shadow-lg"
            />
        </div>
        </div>
      <div className="mt-4 md:mt-6 max-w-7xl mx-auto px-4 md:px-0">
        <h2 className="text-2xl md:text-4xl font-bold text-center text-darklav font-barlow mb-8 md:mb-12">
          SEAN CLARK
        </h2>
        <div className="space-y-4">
          <p className="text-darkgreentext text-base md:text-lg text-center max-w-7xl mx-auto">
              I was born and raised in Salt Lake City, UT.  I loved sports and have always been an advocate of fitness 
              and eating a healthy diet.  Despite what most people would call a fairly healthy lifestyle, I struggled 
              with mysterious joint pain and fatigue that was eventually diagnosed as Fibromyalgia.  I tried many medicines, 
              alternative and conventional treatments, but nothing really helped until I discovered the Wim Hof Method.
          </p>
          <p className="text-darkgreentext text-base md:text-lg text-center max-w-7xl mx-auto">
              The breathing technique that I now teach, I credit with truly giving me my life back!  Coupled with regular cold 
              therapy, practicing an anti-inflammatory diet, exercising, and living life with intentionality, I now live relatively 
              symptom free and it has become my passion to share these simple gifts with anyone who will listen!!  
          </p>
          <p className="text-darkgreentext text-base md:text-lg text-center max-w-7xl mx-auto">
              I trained with Wim Hof in Poland in 2023 and decided to become a Certified Wim Hof Method Instructor.   This method is 
              simple, accessible, and the things you learn from me you can apply to the rest of your life at NO COST.  The air you breathe. 
              Turning the knob on your shower to cold.  Simple.  
          </p>
          <p className="text-darkgreentext text-base md:text-lg text-center max-w-7xl mx-auto">
              And you will become happier, healthier, and stronger.  
          </p>
          <p className="text-darkgreentext text-base md:text-lg text-center max-w-7xl mx-auto">
              While you can always practice on your own, I discovered a sense of community and belonging that supplied its own benefit by 
              practicing with other people and that is what I endeavor to share with all of you who join me in a class setting!!
          </p>
        </div>
        </div>
    </div>
  );
};

export default About;
